import { render, staticRenderFns } from "./peopleNew.vue?vue&type=template&id=e3f28e0e&"
import script from "./peopleNew.vue?vue&type=script&lang=js&"
export * from "./peopleNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports